import http from './http';

export const httpBaseQuery =
    ({ baseUrl } = {}) =>
    async ({ url, method = 'GET', data, body, params, headers }) => {
        try {
            const result = await http({
                url: (baseUrl || '') + url,
                method,
                // axios expects `data`; accept RTK-style `body` as an alias
                data: data ?? body,
                params,
                headers,
            });
            // `meta` is RTK Query's channel for anything outside the body. Only the liveness-session
            // endpoint reads it today, for the `Date` header: it is the one server clock the browser
            // can see, and the face detector needs it to correct a skewed device clock before it
            // signs its own AWS requests.
            return { data: result.data, meta: { status: result.status, headers: result.headers } };
        } catch (error) {
            return {
                error: {
                    status: error.response?.status,
                    data: error.response?.data || error.message,
                },
            };
        }
    };
